const routes = [
  // 加入申请
  {
    // 优惠劵
    path: "/addApply",
    name: "addApply",
    meta: {
      title: "加入申请",
      volcengine: true
    },
    component: () => import("../pages/addApply/index.vue")
  },
];
export default routes;
